export const langs = [
  {
    value: 'en-US',
    native: 'English (US)',
  },
];

export default langs;
